var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable no-console */
import React from 'react';
import Tooltip from '@m4b-design/tooltip';
import { IconQuestionCircle } from '@arco-design/iconbox-react-m4b-next';
import { cs, ID_SUFFIX, isObject } from '../utils';
import { useI18nCopy } from '../hooks/useI18nCopy';
// 标签
var FormItemLabel = function (_a) {
    var _b;
    var htmlFor = _a.htmlFor, showColon = _a.showColon, label = _a.label, prefix = _a.prefix, helpTip = _a.helpTip, subTitle = _a.subTitle, optional = _a.optional, layout = _a.layout, requiredSymbol = _a.requiredSymbol, helpTipTooltipProps = _a.helpTipTooltipProps;
    var prefixCls = "".concat(prefix, "-form-label");
    var isOptional = isObject(optional) ? optional.show : optional;
    // symbolPosition 逻辑不支持变更位置
    // const symbolPosition = isObject(requiredSymbol) ? requiredSymbol.position : 'start';
    var t = useI18nCopy();
    //  空label用于占位使用
    var labelChildren = label !== null && label !== void 0 ? label : React.createElement("div", null, "\u00A0");
    if (isOptional) {
        labelChildren = (React.createElement(React.Fragment, null,
            labelChildren,
            React.createElement("span", { className: "".concat(prefixCls, "-optional") }, isObject(optional) && (optional === null || optional === void 0 ? void 0 : optional.content) ? "".concat(optional === null || optional === void 0 ? void 0 : optional.content) : "(".concat(t.optional, ")"))));
    }
    if (helpTip) {
        var tooltipNode = (React.createElement(Tooltip, __assign({ content: helpTip }, (helpTipTooltipProps !== null && helpTipTooltipProps !== void 0 ? helpTipTooltipProps : {})),
            React.createElement(IconQuestionCircle, { className: "".concat(prefixCls, "-help-icon") })));
        labelChildren = (React.createElement(React.Fragment, null,
            labelChildren,
            tooltipNode));
    }
    var labelClassName = cs((_b = {},
        _b["".concat(prefixCls, "-symbol-before")] = !optional && !!requiredSymbol,
        _b["".concat(prefixCls, "-item-no-subTitle")] = !subTitle,
        _b["".concat(prefixCls, "-colon")] = showColon,
        _b));
    if (layout === 'vertical' && subTitle) {
        return (React.createElement("label", { htmlFor: htmlFor && "".concat(htmlFor).concat(ID_SUFFIX), className: "".concat(prefixCls, "-container") },
            React.createElement("div", { className: "".concat(prefixCls, "-title") }, labelChildren),
            subTitle && (React.createElement("div", { className: "".concat(prefixCls, "-subtitle") }, typeof subTitle === 'string' ? (React.createElement("span", { className: "".concat(prefixCls, "-information") }, subTitle)) : (subTitle)))));
    }
    return (React.createElement("label", { htmlFor: htmlFor, className: labelClassName, title: typeof label === 'string' ? label : '' }, labelChildren));
};
export default FormItemLabel;
